export const listPaymentProfiles = `
   query listPaymentProfiles($filter: PaymentProfilesFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listPaymentProfiles(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              description
              status
              customerId
              customer {
                id
                name
              }
              billingProviderId
              billingProvider {
                id
                name
              }
              providerPaymentMethodId
              providerSpecificData
              createdByUsername
              createdByUser {
                name
                givenName
                familyName
                email
              }
              updatedByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getPaymentProfile = `
   query getPaymentProfile($id:ID!) {
       getPaymentProfile(id:$id) {
         id
         name
         description 
         status
         customerId
         customer {
           id
           name
         }
         billingProviderId
         billingProvider {
           id
           name
         }
         providerPaymentMethodId
         providerSpecificData
         created
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         updated
         updatedByUsername
       } 
}`;
